<template>
<li>
  <CategoryBase
    :category="category"
    @click:expand="toggleChildren"
    :children-expanded="childrenIsOpen"
    :force-highlight="forceHighlight"
  />
  <TransitionExpand>
    <ul v-if="hasChildren && childrenIsOpen" class="ml-1">
      <sidebar-category-inline-nested
        v-for="child in category.children"
        :category="child"
        :force-highlight="childrenIsOpen"
        :key="child.id"
      />
    </ul>
  </TransitionExpand>
</li>
</template>

<script>
import getCategoryRoute from '../getCategoryRoute';
import CategoryBase from './Base';
import TransitionExpand from '@/components/AsyncTransitionExpand';

export default {
  components: {
    TransitionExpand,
    CategoryBase,
  },

  name: 'sidebar-category-inline-nested', // Required so it can render recursively.

  props: {
    category: {},
    forceHighlight: {
      type: Boolean,
    },
  },

  computed: {
    hasChildren() {
      return this.category.children && this.category.children.length > 0;
    },
  },

  methods: {
    toggleChildren() {
      this.childrenIsOpen = !this.childrenIsOpen;
    },
  },

  data() {
    return {
      childrenIsOpen: false
    };
  }
};
</script>
